import { render } from "./AutoTeamBuilder.vue?vue&type=template&id=9bf55540&scoped=true"
import script from "./AutoTeamBuilder.vue?vue&type=script&lang=js"
export * from "./AutoTeamBuilder.vue?vue&type=script&lang=js"

import "./AutoTeamBuilder.vue?vue&type=style&index=0&id=9bf55540&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bf55540"]])

export default __exports__